var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReferrersSearchOption = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4248",
    "data-name": "Group 4248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.303,
    height: 23.274,
    viewBox: "0 0 23.303 23.274",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2848",
    "data-name": "Rectangle 2848",
    width: 3.681,
    height: 7.374,
    fill: "#0d47a1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2849",
    "data-name": "Rectangle 2849",
    width: 5.644,
    height: 10.156,
    fill: "#0d47a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4247",
    "data-name": "Group 4247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4246",
    "data-name": "Group 4246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4245",
    "data-name": "Group 4245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4468",
    "data-name": "Path 4468",
    d: "M53.352,40.126c-1.873,0-3.33.4-4.163,2.423a4.36,4.36,0,0,1,4.163-.808v1.213l2.5-2.02-2.5-2.018Z",
    transform: "translate(-34.072 -27.316)",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4241",
    "data-name": "Group 4241",
    transform: "translate(19.622 14.407)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4240",
    "data-name": "Group 4240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4239",
    "data-name": "Group 4239",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    d: "M66.481,48.336l-2.633,2.129A19.054,19.054,0,0,1,64.6,55.71h2.911c.09-4.415-.283-6.362-1.034-7.374",
    transform: "translate(-63.848 -48.336)",
    fill: "#0d47a1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4244",
    "data-name": "Group 4244",
    transform: "translate(13.592 2.976)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4243",
    "data-name": "Group 4243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4242",
    "data-name": "Group 4242",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    d: "M44.372,19.046c-.034.078-.059.14-.079.194.062.051.126.1.192.145a4.409,4.409,0,0,0,1.124.419c.27.076.541.154.794.246l.243.09a4.832,4.832,0,0,1,2.284-.835,1.479,1.479,0,0,1-.483-.817c-.074-.674.386-.885.7-1.531.073-.149-.059-.4,0-.555.046-.127.207-.149.28-.28a5.489,5.489,0,0,0,.422-.7,18.763,18.763,0,0,0-.14-2.087c0-.252.164-.416.14-.556s-.228-.133-.281-.278.07-.4,0-.558c-.239-.525-.886-.775-1.123-1.389-.83.3-1.31-.792-1.967-.418-.263.148-.217-.235-.7-.14-.143.028,0,.176-.141.278a.435.435,0,0,1-.229.053.83.83,0,0,1,.135.335,1.194,1.194,0,0,1-.116.675.659.659,0,0,0-.063.2c0,.168.045.585.088.954a7.276,7.276,0,0,1,.085,2,2.222,2.222,0,0,1-.392.741c-.084.122-.174.251-.245.379a1.146,1.146,0,0,1-.289.336,1.219,1.219,0,0,1-.073.758,4.306,4.306,0,0,1-.309.527,2.091,2.091,0,0,1,.427,1.258c-.015.2-.135.226-.281.558",
    transform: "translate(-44.226 -9.984)",
    fill: "#0d47a1"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    "data-name": "Path 4471",
    d: "M19.156,16.914l-.024.02v-.095a4.015,4.015,0,0,0-1.342-2.047,4.155,4.155,0,0,0-2.628,1.035l-1.472,1.191.712-1.727a5.361,5.361,0,0,1,1.008-1.624,8.9,8.9,0,0,1-1.976-.714,2.525,2.525,0,0,1-1.135-1.5c-.1-.908.521-1.192.946-2.062.1-.2-.08-.535,0-.746.061-.171.279-.2.377-.377a7.432,7.432,0,0,0,.568-.938A25.345,25.345,0,0,0,14,4.519c.005-.34.22-.561.189-.749s-.307-.178-.379-.375c-.079-.216.095-.543,0-.751C13.489,1.937,12.617,1.6,12.3.773,11.18,1.18,10.534-.293,9.649.21c-.354.2-.292-.317-.946-.189C8.51.059,8.7.257,8.513.4c-.17.123-.664.068-.567,0C7.69.572,7.2,1.18,6.811,1.52a10.306,10.306,0,0,0-1.135.938,2.212,2.212,0,0,1,0,.563c-.028.073-.625.742-.568.938.017.06.37.151.378.186.368,1.72-.628,3.678.947,4.5-.186,1.277.855,1.551.756,2.808-.021.266-.182.3-.379.752-.337.767-.014.528-1.135.938-1.541.561-3.108.96-4.262,2.172-1,1.049-1.4,2.411-1.414,7.96H19.676a20.715,20.715,0,0,0-.52-6.361m-1.9,3.554a.238.238,0,0,1-.24.233H16a.237.237,0,0,0-.24.232v.987a.237.237,0,0,1-.239.233H14.073a.238.238,0,0,1-.241-.233v-.987a.237.237,0,0,0-.24-.232H12.575a.238.238,0,0,1-.24-.233v-1.4a.237.237,0,0,1,.24-.232h1.017a.238.238,0,0,0,.24-.233v-.986a.239.239,0,0,1,.241-.234h1.446a.238.238,0,0,1,.239.234V18.6a.237.237,0,0,0,.24.233h1.018a.237.237,0,0,1,.24.232Z",
    transform: "translate(0 0)",
    fill: "#0d47a1"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReferrersSearchOption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/referrers-search-option.84ce748398764d60b3391a59f9d8b4cc.svg";